import {Trash2} from 'lucide-react';
import {useIntl} from 'react-intl';
import {insightsMessages as m} from '../insightsMessages';
import {lucide} from '../insightsUi';

const formatDeletedOn = (iso: string | null | undefined): string | null => {
    if (!iso) return null;
    const date = new Date(iso);
    if (Number.isNaN(date.getTime())) return null;
    const month = new Intl.DateTimeFormat('en-US', {month: 'short'}).format(date);
    return `${date.getDate()} ${month} ${date.getFullYear()}`;
};

export const RecordingDeletedNotice = ({deletedAt}: {deletedAt?: string | null}) => {
    const intl = useIntl();
    const date = formatDeletedOn(deletedAt);
    return (
        <div role="note" data-testid="insights-recording-deleted" className="flex min-h-[52px] items-center gap-3 rounded-control bg-surface-muted px-3 py-2">
            <span className="inline-flex size-8 shrink-0 items-center justify-center rounded-control bg-surface text-ink-muted">
                <Trash2 size={16} aria-hidden="true" className={lucide}/>
            </span>
            <div className="flex min-w-0 flex-col gap-0.5">
                <span className="text-callout font-semibold text-ink">{intl.formatMessage(m.recordingDeleted)}</span>
                <span className="text-footnote text-ink-muted">
                    {date ? `${intl.formatMessage(m.recordingDeletedOn, {date})} · ` : ''}{intl.formatMessage(m.recordingDeletedHint)}
                </span>
            </div>
        </div>
    );
};
